import { runtimeConfig } from '@app/common/config'
import { TestVariantsIdsLocationFilter } from '@app/store/booking'

const experimentIdLocationFilter = runtimeConfig.joinSproutTherapyConfig?.GO_EXPERIMENT_ID_LOCATION_FILTER

export const isControlVariantLocationFilter = (variantId: TestVariantsIdsLocationFilter) => {
  return variantId === TestVariantsIdsLocationFilter.Control
}

export const isZipCodeValidationNeeded = (variantId: TestVariantsIdsLocationFilter) => {
  return !!(!experimentIdLocationFilter || (experimentIdLocationFilter && isControlVariantLocationFilter(variantId)))
}
